<template>
    <div>
        <div class="card m-3 shadow">

            <!--cabezera-->
            <div class="card-header">

                <div class="d-flex">
                    <div class="flex-fill">
                        <MeetingSearch></MeetingSearch>
                    </div>

                    <div class="float-end">
                        <MeetingPagination></MeetingPagination>
                    </div>

                </div>

            </div>

            <!--cuerpo-->
            <div class="card-body">

                <MeetingTable></MeetingTable>

            </div>
        </div>
    </div>
</template>
<script>
import MeetingSearch from '@/components/Meeting/MeetingList/Meeting-search.vue'
import MeetingPagination from '@/components/Meeting/MeetingList/Meeting-pagination.vue'
import MeetingTable from '@/components/Meeting/MeetingList/Meeting-table.vue'

export default {
    name: 'MeetingList',

    components:{
        MeetingSearch,
        MeetingPagination,
        MeetingTable
    }

}
</script>
<style></style>